import React, { useContext, useEffect, useState } from 'react';
import { Form, Transfer, Input, Spin, Typography } from 'antd';

import MarketingAudienceShowContent from '../../MarketingAudienceShowContent';
import { CreateAudienceDataContext } from '../../../../../helpers/Context';
import { apiGetUsersList, apiGetUsersListManual } from '../../../../../helpers/Api';
import { addKeys } from '../../../../../helpers/AddKey';

export default function UsersFilters() {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [page, setPage] = useState(1);
  const [dataSource, setDataSource] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const { form, globalContext, handleFormChanged, audienceData } = useContext(CreateAudienceDataContext);
  const { publicCode, errorNotification } = globalContext;

  const formatUser = (user) => ({
    key: user.idCustomer,
    title: `${user.name || ''} ${user.surname || ''}`.trim() || user.email || user.idCustomer,
    description: user.email,
    ...user, // preserva gli altri dati
  });

  const mergeByKey = (a, b) => {
    const map = {};
    [...a, ...b].forEach((item) => {
      map[item.key] = item;
    });
    return Object.values(map);
  };

  const fetchSelectedUsers = async () => {
    if (!publicCode || !audienceData) return;

    setLoading(true);
    const body = {
      public_code: publicCode,
      audienceCampaignIds: [audienceData.id],
      page: 1,
    };

    try {
      const res = await apiGetUsersListManual(body, '');

      if (!res.message) {
        const formatted = addKeys(res?.users, 'idCustomer').map(formatUser);
        setSelectedUsers(formatted);
        setTargetKeys(formatted.map((u) => u.key));
        return formatted;
      } else {
        errorNotification(res.message);
      }
    } catch (error) {
      errorNotification('Errore durante il recupero utenti');
      console.error('Errore durante il recupero utenti:', error);
    } finally {
      setLoading(false);
    }
    return [];
  };

  const fetchUsers = async (query = '', selected = []) => {
    if (!publicCode) return;

    setLoading(true);
    const body = {
      public_code: publicCode,
      audienceCampaignIds: [],
      page,
    };

    try {
      const res = await apiGetUsersList(body, query);

      if (!res.message) {
        const formatted = addKeys(res?.users, 'idCustomer').map(formatUser);
        const merged = mergeByKey(formatted, selected);
        setDataSource(merged);
        setTotalUsers(res.totalUsers);
        setTotalPages(res.totalPages);
      } else {
        errorNotification(res.message);
      }
    } catch (error) {
      errorNotification('Errore durante il recupero utenti');
      console.error('Errore durante il recupero utenti:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      const selected = await fetchSelectedUsers(); // ritorna i selezionati
      await fetchUsers('', selected); // passa i selezionati per merge
    };
    init();
  }, []);

  const handleSearchText = (e) => {
    setSearch(e.target.value);
  };

  const onSearch = () => {
    const selected = targetKeys.map(key => dataSource.find(u => u.key === key)).filter(Boolean);
    fetchUsers(search, selected);
  };


  const handleChange = (nextKeys) => {
    setTargetKeys(nextKeys);
    form.setFieldsValue({ users_ids_list: nextKeys });
    handleFormChanged();
  };

  return (
    <div className="mt-20 mb-20 p-10">
      <Form.Item name="users_ids_list" initialValue={[]}>
        <div className="di-card bg-dark-02">
          <Input.Search
            placeholder="Cerca per nome, cognome o email"
            onChange={handleSearchText}
            onSearch={onSearch}
            value={search}
            allowClear
          />

          <Spin spinning={loading}>
            <Transfer
              showSelectAll={false}
              titles={[
                `Tutti gli utenti Disponibili (${totalUsers})`,
                `Utenti nel pubblico Selezionati (${targetKeys.length})`,
              ]}
              locale={{
                itemUnit: 'Utente',
                itemsUnit: 'Utenti',
              }}
              className="di-audience-users-transfer mt-20"
              dataSource={dataSource}
              targetKeys={targetKeys}
              onChange={handleChange}
              render={(item) => (
                <div>
                  <Typography>{`${item.name || ''} ${item.surname || ''}`}</Typography>
                  <Typography className="fs-12">{item.email}</Typography>
                </div>
              )}
              listStyle={{
                width: '100%',
                height: 300,
              }}
            />
          </Spin>
        </div>
      </Form.Item>
    </div>
  );
}
